import axios from "../../../services/api/axios-default";
import _ from "lodash";
import { STORAGE_KEY_WHITEBOARD_DATA, SELECT_EMPTY_VALUE } from "../../../services/managers/constants";
import { MSG_VIEW_CHART_VALIDATE_LOADING, MSG_VIEW_CHART_LOADING, MSG_ERR_INVALID_CHART_DATA } from "../../../services/managers/string-literals";
import pagePreloaderManager from "../../../services/managers/page-preloader";
import validationManager from "../../../services/managers/validation";
import httpManager from "../../../services/managers/http";
import webStorageManager from "../../../services/managers/web-storage";
import chartDataTransformer from "../../../services/transformers/chart-data";
import * as actions from "./actions";

export const onSelectedPrimaryChartChange = (payload) => ({
  type: actions.ON_SELECTED_PRIMARY_CHART_CHANGE,
  payload: { ...payload }
});

export const onSelectedComparisonChartChange = (payload) => ({
  type: actions.ON_SELECTED_COMPARISON_CHART_CHANGE,
  payload: { ...payload }
});

export const onSelectedChartLayerChange = (payload) => ({
  type: actions.ON_SELECTED_CHART_LAYER_CHANGE,
  payload: { ...payload }
});

export const onViewChartClick = (payload) => (dispatch, getState) => {
  // Validate if all required filters and chart options are selected
  if (!validationManager.validateViewChart(getState().analytics, payload.whiteboardIndex)) {
    dispatch((() => ({ type: actions.ON_VIEW_CHART_CLICK, payload: { ...payload, validationFailure: true } }))());
  } else {
    pagePreloaderManager.showChartLoader(payload.whiteboardIndex, MSG_VIEW_CHART_LOADING);

    let whiteboard = getState().analytics.chartWhiteboards[payload.whiteboardIndex];

    if (whiteboard.selectedComparisonChart && whiteboard.selectedComparisonChart !== SELECT_EMPTY_VALUE) {
      let primaryEndpoint = httpManager.getApplicableChartDataEnpoint(whiteboard.selectedPrimaryChart);
      let comparisonEndpoint = httpManager.getApplicableChartDataEnpoint(whiteboard.selectedComparisonChart);
      let queryString = httpManager.constructChartDataHttpQueryString(getState().analytics, payload.whiteboardIndex);

      // For overlay comparison, two concurrent API calls are required

      Promise.all([axios.get(primaryEndpoint + "?" + queryString), axios.get(comparisonEndpoint + "?" + queryString)])
        .then(([primaryResponse, comparisonResponse]) => {
          if (
            primaryResponse.data &&
            comparisonResponse.data &&
            primaryResponse.data.response &&
            comparisonResponse.data.response &&
            _.isArray(primaryResponse.data.response) &&
            _.isArray(comparisonResponse.data.response) &&
            primaryResponse.data.response.length &&
            comparisonResponse.data.response.length &&
            primaryResponse.data.response.length === comparisonResponse.data.response.length
          ) {
            // Merge Primary and Comparison data into one array
            let mergedResponse = chartDataTransformer.mergeOverlayComparisonData(primaryResponse.data.response, comparisonResponse.data.response);

            // Cache chart data for use in the component
            webStorageManager.set(STORAGE_KEY_WHITEBOARD_DATA + payload.whiteboardIndex, mergedResponse);
            dispatch(((response) => ({ type: actions.ON_VIEW_CHART_CLICK, payload: { ...payload, response } }))(mergedResponse));
          } else {
            let error = MSG_ERR_INVALID_CHART_DATA;
            dispatch(((error) => ({ type: actions.ON_VIEW_CHART_CLICK, payload: { ...payload, error } }))(error));
          }
        })
        .catch(function(error) {
          console.error("Catch Error", JSON.stringify(error));
          error = httpManager.transfigureAPIErrorMessages(error);
          dispatch(((error) => ({ type: actions.ON_VIEW_CHART_CLICK, payload: { ...payload, error } }))(error));
        });
    } else {
      let endpoint = httpManager.getApplicableChartDataEnpoint(getState().analytics.chartWhiteboards[payload.whiteboardIndex].selectedPrimaryChart);
      let queryString = httpManager.constructChartDataHttpQueryString(getState().analytics, payload.whiteboardIndex);

      // Call API to fetch data for drawing of chart
      axios
        .get(endpoint + "?" + queryString)
        .then(function(response) {
          if (response.data && response.data.response && _.isArray(response.data.response) && response.data.response.length) {
            // Cache chart data for use in the component
            webStorageManager.set(STORAGE_KEY_WHITEBOARD_DATA + payload.whiteboardIndex, response.data.response);
            dispatch(((response) => ({ type: actions.ON_VIEW_CHART_CLICK, payload: { ...payload, response } }))(response.data.response));
          } else {
            let error = MSG_ERR_INVALID_CHART_DATA;
            dispatch(((error) => ({ type: actions.ON_VIEW_CHART_CLICK, payload: { ...payload, error } }))(error));
          }
        })
        .catch(function(error) {
          console.error("Catch Error", JSON.stringify(error));
          error = httpManager.transfigureAPIErrorMessages(error);
          dispatch(((error) => ({ type: actions.ON_VIEW_CHART_CLICK, payload: { ...payload, error } }))(error));
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-header/action-creators.js